module.exports = __webpack_public_path__ + "img/general-henry-s.-huidekoper.4aa66cc9.png";